module.exports = __webpack_public_path__ + "img/zhaoyufeng.e28040ba.jpg";